var map = {
  "./": "25743",
  "./background.svg": "13020",
  "./behaviour.svg": "97313",
  "./checklist.svg": "53304",
  "./clinicalstudy.svg": "60894",
  "./clpAndCnpTests.svg": "58082",
  "./cognition.svg": "73720",
  "./comorbidity.svg": "98699",
  "./dbs.svg": "76273",
  "./diagnosis.svg": "83455",
  "./diagnosticSurvey.svg": "83783",
  "./dietTherapy.svg": "21069",
  "./examination.svg": "16303",
  "./functionalPerformance.svg": "86647",
  "./generalhealth.svg": "36514",
  "./genericDocument.svg": "84852",
  "./genetest.svg": "1807",
  "./graph.svg": "73996",
  "./imaging.svg": "48522",
  "./index": "25743",
  "./index.tsx": "25743",
  "./inflammatoryDiseaseActivity.svg": "65132",
  "./interviewSurveys.svg": "64794",
  "./lifestyle.svg": "4893",
  "./medication.svg": "62257",
  "./motor.svg": "21323",
  "./motorfunction.svg": "66639",
  "./motorfunctionHuntington.svg": "44371",
  "./myService.svg": "48083",
  "./myServiceV2.svg": "13559",
  "./neurological.svg": "64862",
  "./notes.svg": "81263",
  "./nutrition.svg": "49344",
  "./profile.svg": "92903",
  "./pulmonary.svg": "715",
  "./relapse.svg": "15834",
  "./seizure.svg": "8529",
  "./surgicalTreatment.svg": "22810",
  "./therapy.svg": "57947",
  "./treatment.svg": "39596",
  "./updrs.svg": "86960"
};


function __rspack_context(req) {
  var id = __rspack_context_resolve(req);
  return __webpack_require__(id);
}
function __rspack_context_resolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
__rspack_context.keys = function webpackContextKeys() {
  return Object.keys(map);
};
__rspack_context.resolve = __rspack_context_resolve;
module.exports = __rspack_context;
__rspack_context.id = 45208;
